"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Email = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function Email(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 2.66663H2.66668C1.9303 2.66663 1.33334 3.26358 1.33334 3.99996V12C1.33334 12.7363 1.9303 13.3333 2.66668 13.3333H13.3333C14.0697 13.3333 14.6667 12.7363 14.6667 12V3.99996C14.6667 3.26358 14.0697 2.66663 13.3333 2.66663ZM13.3333 3.99996V5.93329L8.43334 9.36663C8.17276 9.54748 7.82726 9.54748 7.56668 9.36663L2.66668 5.93329V3.99996H13.3333ZM2.66668 7.33329V12H13.3333V7.33329L9.10001 10.2933C8.43937 10.7551 7.56064 10.7551 6.90001 10.2933L2.66668 7.33329Z",
    fill: "currentColor"
  }));
}

exports.Email = Email;